import { Base } from '../base-component';

import './content-card-item.component.scss';
import SliderComponent from '../slider/slider.component';
import { MediaQueryService } from '../../services/media-query.service';

export class ContentCardItem extends Base {

	constructor(element){
		super(element)
	}

	init() {}

	bindEvents() {}

}



// WEBPACK FOOTER //
// ./components/content-card-item/content-card-item.component.ts